<script>
import MlUploadImage from '@/components/MlUploadImg/single.vue'

export default {
  name: 'UploadVoucher',
  components: { MlUploadImage },
  data() {
    return {
      dialogFormVisible: false,
      dialogLoading: false,
      dialogArtistVisible: false,
      dialogTitle: '',
      dialogForm: {
        id: 0,//分成记录ID
        voucher_id: 0// 凭据图片ID
      },
      dialogFormRules: {
        id: [
          { required: true, message: '分成记录ID必填', trigger: 'change' }
        ],
        voucher_id: [
          { required: true, message: '凭据图片必传', trigger: 'change' }
        ]
      },
      date_time: null,
      pickerOptions: {
        disabledDate: (time) => {
          // console.log('time',time.getTime(),this.date_time,this.dialogForm.exec_date)
          // 获取指定月份的第一天和最后一天
          const monthStart = new Date(this.date_time).getTime()
          const monthEnd = new Date(`${this.date_time} 23:59:59`).getTime()

          // 不在指定月份范围内的日期都禁用
          return time.getTime() < monthStart || time.getTime() > monthEnd
        }
      }
    }
  },
  methods: {
    add(divideDetail) {
      this.dialogFormVisible = true
      this.dialogTitle = '打款凭证'
      this.date_time = divideDetail.date_time
      this.dialogForm = {
        id: divideDetail.id,
        voucher_id: null,
        // artist_id: divideDetail.artist_id,
        // nickname: divideDetail.nickname,
        // exec_date: `${divideDetail.date_time}`,
      }
    },
    // 弹窗关闭时清空数据
    handleDialogClose() {
      this.dialogForm = {
        id: 0,
        voucher_id: 0,
      }
      // 清除表单验证状态
      if (this.$refs.dialogFormRef) {
        this.$refs.dialogFormRef.clearValidate()
      }
    },

    // 表单提交
    async handleSubmit() {
      this.$refs.dialogFormRef.validate(async (valid) => {
        if (valid) {
          this.dialogLoading = true
          try {
            setTimeout(() => {
              this.dialogLoading = false
            }, 1000)
            const data = await this.$api.updateArtistDivideVoucher(this.dialogForm)
            if (data) {
              if (this.dialogForm.id) {
                this.msgSuccess('提交成功')
              } else {
                this.msgSuccess('提交成功')
                // this.$notify.success('新增成功')
              }
              this.dialogFormVisible = false

              this.$emit('saved', data)
            } else {
              this.$notify.error('新增失败')
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$notify.error('提交失败，请重试')
          } finally {
            this.dialogLoading = false
          }
        } else {
          this.dialogLoading = false
          this.$notify.warning('请填写必填项')
          return false
        }
      })
    },
    //上传凭据
    handleUploadFile(obj) {
      //{ id: this.img_id, src: this.img_url
      this.dialogForm.voucher_id = obj.id || null

    }
  }

}

</script>

<template>
  <div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogFormVisible' width='600px' @close='handleDialogClose'>

      <el-form :model='dialogForm'
               :rules='dialogFormRules'
               ref='dialogFormRef'
               size='small'
               label-suffix='：'>
        <el-form-item label='' prop='voucher_id'>
          <!--          <el-input v-model='dialogForm.voucher_id'></el-input>-->
          <div class='theme-border padding-effect flex-center' style='min-height: 200px;'>
            <MlUploadImage style='min-width: 64px;min-height: 64px;' title='点击上传凭据' @success='handleUploadFile' />
          </div>
        </el-form-item>
        <el-form-item style='text-align: center'>
          <el-button round size='medium' type='primary' @click='handleSubmit' :disabled='dialogLoading' :loading='dialogLoading'>提交凭据</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>
